
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/second-cond-explanation';
const mainimage = '/Images/secondcondprod1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "grammar", subtype: "second-cond-prod" },
];

const SecondCondProd = () => (
  <GrammarPageLayout
    level="B1"
    title="Second Cond Prod"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Second Conditional Grammar Practice"
    seoDescription="Advanced second conditional practice with production exercises. B2 level."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default SecondCondProd;

